import { motion } from "framer-motion";
import { waLink, DEFAULT_QUOTE_MESSAGE } from "../../lib/site";
import { WhatsAppIcon } from "./bits";

export const FloatingWhatsApp = () => (
    <motion.a
        href={waLink(DEFAULT_QUOTE_MESSAGE)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Pedir cotação no WhatsApp"
        data-testid="floating-whatsapp-cta-button"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-zap text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110"
    >
        <span className="animate-pulse-ring absolute inset-0 rounded-full bg-zap" />
        <WhatsAppIcon className="relative h-7 w-7" />
    </motion.a>
);
